import Box from '@mui/material/Box';

import { logoFull, logoMark } from '../../../assets/figma';

import { brandMarkStyles as styles } from './BrandMark.styles';

interface BrandMarkProps {
  /** Render the mark alone, or the full wordmark from Figma. */
  variant?: 'mark' | 'full';
  /** Height in px. Width scales with the SVG aspect ratio. */
  height?: number;
  title?: string;
}

/**
 * 530A Solutions brand mark — the icon glyph (`logoMark`, unchanged since
 * Figma Top nav node I142:40355;142:40322) plus the current wordmark
 * lockup (`logoFull`, node 142:40323).
 */
export function BrandMark({
  variant = 'full',
  height = 36,
  title = '530A Solutions',
}: BrandMarkProps) {
  const src = variant === 'mark' ? logoMark : logoFull;
  return (
    <Box sx={{ ...styles.root, height }} aria-hidden={false}>
      <Box
        component="img"
        src={src}
        alt={title}
        sx={{ ...styles.img, height }}
      />
    </Box>
  );
}
